interface Props {
  width?: string;
  height?: string;
  className?: string;
}
const SPKCardSkeleton = ({ width, height, className }: Props) => {
  return (
    <div className={`${width} ${height} animate-pulse-skeleton ${className}`} />
  );
};

SPKCardSkeleton.defaultProps = {
  width: 'w-full',
  height: 'h-4',
  className: '',
};

export default SPKCardSkeleton;
